import CheckIcon from '@mui/icons-material/Check';
import {
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import { sortOptions } from 'pages/iPriseV2/common/enum/TeamUserRoles';
import React, { memo } from 'react';

interface SortMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  selectedSort: string;
  onSelect: (sort: string) => void;
}

const SortMenu: React.FC<SortMenuProps> = ({
  anchorEl,
  open,
  onClose,
  selectedSort,
  onSelect,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      className="sort-select-menu"
      PaperProps={{
        className: 'sort-menu-paper',
        elevation: 0,
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
      <Typography className="menu-title">Sort By</Typography>
      <Box className="menu-content">
        {sortOptions.map((option, index) => {
          if (option.type === 'divider') {
            return (
              <Divider key={`divider-${index}`} className="menu-divider" />
            );
          }

          const isSelected = selectedSort === option.value;

          return (
            <MenuItem
              key={option.value}
              onClick={() => option.value && onSelect(option.value)}
              className={`menu-item ${isSelected ? 'selected' : ''}`}>
              <ListItemIcon className="menu-icon">
                {isSelected && <CheckIcon fontSize="small" />}
              </ListItemIcon>
              <Typography className="menu-text">{option.label}</Typography>
            </MenuItem>
          );
        })}
      </Box>
    </Menu>
  );
};

export default memo(SortMenu);
